<template>
    <div class="big-stavka-wrapper">
        <div class="troskovnik-element-title">{{stavka_name}}</div>
        <div class="troskovnik-stavke-wrapper">
            <div class="fiksne-stavke-header">
                <div class="st sst1">{{text_name}}</div>
                <div class="st sst2">Iznos</div>
            </div>
            <div class="stavke-wrapper">
                <div class="stavke-row" v-for="(stavka,key) in stavke" :key="key">
                    <div class="row-number">{{key+1}}</div>
                    <div class="fiksna-stavka">
                        <input type="text" class="stavka-opis sst1" v-model="stavka.opis">
                        <div class="vertical-divider"></div>
                        <input type="text" class="stavka-iznos sst2" v-model="stavka.iznos"  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');">
                    </div>
                    <div class="add-napomena add-button remove-item" @click="deleteStavka(stavka)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                            <g><g><path fill="#70707E" d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" /></g></g>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="add-new" @click="add_new">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" id="SVGDoc" width="12" height="12" version="1.1" viewBox="0 0 12 12"><defs/><desc>Generated with Avocode.</desc><g><g><title>Shape 544</title><path d="M10.88006,4.71948c-0.14734,-0.14586 -0.32628,-0.2183 -0.5368,-0.2183h-3.28338v0v-3.24824c0,-0.20795 -0.07367,-0.38519 -0.22101,-0.53089c-0.14722,-0.1457 -0.32604,-0.21863 -0.5368,-0.21863h-1.51527c-0.21052,0 -0.38934,0.07293 -0.53668,0.21863c-0.14734,0.1457 -0.22101,0.32294 -0.22101,0.53089v3.24824v0h-3.28338c-0.2104,0 -0.38934,0.07243 -0.53668,0.2183c-0.14746,0.14603 -0.22101,0.3226 -0.22101,0.53072v1.4992c0,0.20828 0.07355,0.38536 0.22101,0.53105c0.14734,0.1457 0.32628,0.21846 0.53668,0.21846h3.28326v0v3.2479c0,0.20812 0.07379,0.38536 0.22113,0.53105c0.14734,0.1457 0.32616,0.2183 0.53668,0.2183h1.51539c0.21064,0 0.38934,-0.0726 0.53668,-0.2183c0.14746,-0.1457 0.22113,-0.32294 0.22113,-0.53105v-3.2479v0h3.28326c0.21064,0 0.38958,-0.07277 0.5368,-0.21846c0.14734,-0.1457 0.22101,-0.32277 0.22101,-0.53105v-1.4992c0,-0.20812 -0.07367,-0.38502 -0.22101,-0.53072z" fill="#7b7b8a" fill-opacity="1"/></g></g></svg>
                <span>{{add_text}}</span>
            </div>
            <div class="subtotal-wrapper">
                <div class="subtotal-value"><span>ukupno</span><span>{{getValue.toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}} {{valuta}}</span></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['stavka_name','text_name','add_text','valuta','stavke'],
    methods: {
        add_new(){
            this.stavke.push({opis:'',iznos:0})
        },
        deleteStavka(delete_this){
            this.stavke = this.stavke.filter(st=>st != delete_this)
        }
    },
    computed:{
        getValue(){
            return this.stavke != undefined ? this.stavke.reduce(function(prev,next){return prev+Number(next.iznos)},0) : 0;
        },
    }
}
</script>